<template>
  <!--
    Displays the differences between an old and a new configuration file.
  -->
  <pre
    ref="preComp"
    :class="!isConfiguration ? 'f-col' : ''"
  />
</template>

<script>

import * as diff from 'diff'

export default {
  name: 'AuditLogCompare',
  props: {
    oldVal: {
      type: [String, Array, Number, Boolean, Object],
      required: false,
      default: " "
    },
    newVal: {
      type: [String, Array, Number, Boolean, Object],
      required: false,
      default: " "
    },
    isConfiguration: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  watch: {
    oldVal () {
      this.getDiff();
    },
    newVal () {
      this.getDiff();
    }
  },
  mounted () {
    this.getDiff();
  },
  methods: {
    getDiff () {
      if (this.$refs.preComp) {
        this.$refs.preComp.textContent = '';
      }
      var fragment = document.createDocumentFragment();
      var dif = diff.diffLines(this.normalizeValue(this.oldVal), this.normalizeValue(this.newVal));
      dif.forEach((part) => {
        var color = part.added ? 'green' :
          part.removed ? 'red' : 'black';
        var span = document.createElement('span');
        span.style.color = color;
        span.appendChild(document
          .createTextNode(part.value));
        fragment.appendChild(span);
      });
      this.$refs.preComp.appendChild(fragment);
    },
    normalizeValue (value) {
      if (value == null) {
        return '';
      }
      if (Array.isArray(value)) {
        return value.map(item => this.normalizeArrayItem(item)).join('\n');
      }
      if (typeof value === 'object') {
        return JSON.stringify(value, null, 2);
      }
      return String(value);
    },
    normalizeArrayItem (item) {
      if (item == null) {
        return '';
      }
      if (Array.isArray(item)) {
        return JSON.stringify(item, null, 2);
      }
      if (typeof item === 'object') {
        return JSON.stringify(item, null, 2);
      }
      return String(item);
    }
  }
}
</script>

<style>
pre {
  white-space: pre-line;
}
.f-col {
  display:flex; 
  flex-direction:column;
}
</style>
